import { EFloorTypes } from 'shared/types/filters/advanced/floorTypes';

export const mapFloorTypeLabel = {
  [EFloorTypes.OnlyFirstFloor]: 'Только первый',
  [EFloorTypes.NotBasement]: 'Не цоколь, не подвал',
};
